export const CONFIG = {
  base_url: import.meta.env.VITE_HOST_API,
  file_url: import.meta.env.VITE_FILE_URL,
  host_api: import.meta.env.VITE_HOST_API,
  yandexKey: {
    key: import.meta.env.VITE_MAP_API_KEY,
    geo_api: import.meta.env.VITE_MAP_GEO_API,
  },
  sentry_dsn: import.meta.env.VITE_SENTRY_DSN,
};
